// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__Fj7UM","tyre":"style_tyre__s+6qd"};